var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdProtectionShieldFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23C9.375 22.3583 7.21875 20.8687 5.53125 18.5312C3.84375 16.1938 3 13.6317 3 10.845V4.3L12 1L21 4.3V10.845C21 13.6317 20.1562 16.1938 18.4688 18.5312C16.7812 20.8687 14.625 22.3583 12 23ZM12 21.295C13.9875 20.6533 15.6328 19.4754 16.9359 17.7612C18.2391 16.0471 19.0031 14.1267 19.2281 12H12V2.7875L4.6875 5.455V10.845C4.6875 11.065 4.69219 11.2529 4.70156 11.4087C4.71094 11.5646 4.73438 11.7617 4.77187 12H12V21.295Z",
    fill: "#FCD800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdProtectionShieldFilled);
export default __webpack_public_path__ + "static/media/id_protection_shield_filled.0ecc88fac7e679ed7c8dab9831b1c363.svg";
export { ForwardRef as ReactComponent };